// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-view-chart-sec button>.tree-card .card-title {
    font-size: 18px;
    margin-bottom: 0px;
    text-align: left;
}

.tree-view-chart-sec button>.tree-card {
    max-width: 400px;
    box-shadow: 0px 10px 20px -10px #dad8d8;
}

/* .tree-Modal .modal-dialog {
    max-width: calc(100% - 5rem) !important;
} */

.tree-Modal .tree-card-content .vid-select select {
    width: 100%;
    border-bottom: 1px solid #5c5c5c;
    border-radius: 0;
    margin-bottom: 10px;
    font-size: 15px;
}

.pathways-colors {
    margin: 0px 5px 10px;
    width: 60px;
    height: 30px;
    border-radius: 10px;
}

.tree-Modal .tree-card-content .opts-row button img {
    width: 20px;
    height: 20px;
}

.url{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.preview-image-none {
    font-size: 22px;
    background: #e1e1e1;
    height: 300px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-image {
    width: 100%;
    height: auto;
    max-height: 300px;
    cursor: pointer;
    object-fit: contain;
}

.publish-vid .thumbnail-area .select-thumb img.deletrThumnails {
    width: 30px;
    height: auto;
    /* margin-top: -43px; */
    text-align: center;
    margin-top: 5px;
    padding: 5px;
}

.publish-vid .thumbnail-area .select-thumb img.deletrThumnails:hover {
    background: #ccc;
}

.tree-Modal .tree-card-vid .leave-btn,
.tree-Modal .tree-card-vid .more-btn {
    position: absolute;
    top: 8px;
    z-index: 99;
}

/*.video-card {*/
/*  cursor: pointer;*/
/*}*/

.tree-Modal .tree-card-vid .leave-btn {
    left: 14px;
    color: #ffffff;
    opacity: 1;
    font-weight: 400;
    font-size: 16px;
}

.tree-Modal .tree-card-vid .more-btn {
    right: 8px;
}

.civ-message .msg-description {
    overflow-wrap: anywhere;
}


.objectives {
    width: 300px;
    position: relative;
    margin: 11px 0 0 0;
}

.objectives input {
    margin: 0px;
    padding: 0px;
    width: 100%;
    outline: none;
    height: 40px;
    border-radius: 5px;
    border: none;
    padding: 0 0 0 5px;
}

.objectives button {
    position: absolute;
    top: 0;
    right: -2px;
    z-index: 2;
    border: none;
    top: 0;
    height: 40px;
    cursor: pointer;
    transform: translateX(2px);
    width: 36px;
}

.objectives i {
    font-size: 18px;
    line-height: 2;
    color: #6c6c6c;
}

.objectImg img {
    height: 40px;
}

.objectImg span i {
    font-size: 18px;
    cursor: pointer;
    color: #6c6c6c;
}

.objectivesButtons .btnDone {
    background: #9b4dca;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

.objectivesButtons .btnCancel {
    background: #6c6c6c;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

/*.tree-Modal .tree-card-vid .more-btn button {*/
/*  padding: 0px 10px;*/
/*}*/

/*.tree-Modal .tree-card-vid .more-btn button:after {*/
/*  display: none;*/
/*}*/

/*.tree-Modal {*/
/*  padding-right: 15px !important;*/
/*  padding-left: 15px !important;*/
/*}*/

/* WC 08282022
/* ORIGINAL
.tree-Modal .tree-card-vid .more-btn .dropdown-menu {
  left: -126px !important;
  transform: unset !important;
  top: 25px !important;
  padding: 0px;
} */

/* UPDATE */
/*.tree-Modal .tree-card-vid .more-btn .dropdown-menu {*/
/*  left: -25px !important;*/
/*  transform: unset !important;*/
/*  top: 25px !important;*/
/*  padding: 0px;*/
/*  min-width: auto;*/
/*}*/
/*!* WC 08282022 *!*/

/*.tree-Modal .tree-card-vid .more-btn .dropdown-menu a {*/
/*  border-bottom: 1px solid #5c5c5c;*/
/*  font-size: 15px;*/
/*  padding: 8px 12px;*/
/*}*/

/*.tree-Modal .tree-card-vid .more-btn .dropdown-menu span {*/
/*  position: absolute;*/
/*  top: -6px;*/
/*  right: 6px;*/
/*  width: 0;*/
/*  height: 0;*/
/*  border-left: 8px solid transparent;*/
/*  border-right: 8px solid transparent;*/
/*  border-bottom: 10px solid #ffffff;*/
/*}*/

.tree-Modal .tree-card-content .check-line span {
    width: 20px;
    height: 20px;
    border: 1px solid black;
    display: inline-block;
    margin-right: 8px;
}

.tree-Modal .tree-card-content .check-line input {
    color: #000;
    margin-left: 10px;
    border: 0px;
    width: 6vw;
    border-bottom: 1px solid #ccc;
    font: 400 14px/20px Roboto, "Helvetica Neue", sans-serif;
}

.tree-Modal .tree-card-content .check-line label {
    cursor: pointer;
    font-size: 15px;
}

.tree-Modal .tree-card-content .check-line input:checked+label:after {
    content: "";
    position: absolute;
    left: 22px;
    top: 5px;
    width: 6px;
    height: 14px;
    border: solid #6e5eff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.tree-Modal .tree-card-vid video {
    outline: none;
}

.find-peoples-sec .search-area .share-btn {
    width: 100%;
    background: #6e5eff;
    color: #ffffff;
}

.find-peoples-sec .search-area .search button {
    position: absolute;
}

.find-peoples-sec .search-area .search input {
    padding-left: 40px;
    font-size: 15px;
}

.FF-scroll-modify {
    max-height: 360px;
    height: auto;
    overflow-x: hidden;
    overflow-y: scroll;
}

textarea::-webkit-scrollbar {
    width: 6px;
}

textarea::-webkit-scrollbar-track {
    background: transparent;
}

textarea::-webkit-scrollbar-thumb {
    background: #ebebed;
    border-radius: 50px;
}

textarea::-webkit-scrollbar-thumb:hover {
    background: #d9d9db;
}

#vid-search-btn {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9;
}

.checknbox input {
    width: 18px;
    height: 18px;
    margin-top: 37px;
}

.checknbox label {
    display: block;
    margin: 0;
    height: 100%;
    text-align: center;
    cursor: pointer;
    width: 100%;
}

.custom-label {
    display: block;
    margin: 0;
    width: 100%;
    text-align: center;
    cursor: pointer;
}

.symbol-class {
    height: 40px;
    margin-right: 5px;
}

.selected-item {
    background-color: #ccc;
    padding: 0px 21px;
    height: 224px;
}

.find-peoples-sec .select-area .FF-scroll-modify {
    height: 133px;
}

.find-peoples-sec .select-area .form-check {
    margin-bottom: 14px;
}

.find-peoples-sec .select-area .form-check span {
    display: inline-block;
    width: 35px;
    height: 35px;
    border: 1px solid #e6e3e3;
    border-radius: 50%;
    margin-right: 10px;
}

.find-peoples-sec .select-area .form-check input {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    margin-left: 0px;
}

.find-peoples-sec .select-area .form-check span img {
    width: 100%;
    height: 100%;
}

.find-peoples-sec .select-area .form-check input:checked+label {
    color: #6e5eff;
}

.find-peoples-sec .select-area .form-check input:checked+label:after {
    content: "";
    position: absolute;
    left: 13px;
    top: 8px;
    width: 10px;
    height: 17px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

.find-peoples-sec .select-area .form-check input:checked+label:before {
    content: "";
    width: 35px;
    height: 35px;
    background-color: #6e5effcc;
    position: absolute;
    left: 0px;
    top: 0px;
    border-radius: 50%;
}

/* Tree chart select & share Modal */

.tree-share-Modal,
.tree-preview-vid-Modal,
.tree-publish-vid-Modal {
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.tree-share-Modal .modal-body,
.tree-share-Modal .modal-header,
.tree-preview-vid-Modal .modal-body,
.tree-preview-vid-Modal .modal-header,
.tree-publish-vid-Modal .modal-body,
.tree-publish-vid-Modal .modal-header {
    padding: 20px 25px 25px 25px;
}

.tree-share-Modal .modal-title,
.tree-preview-vid-Modal .modal-title,
.tree-publish-vid-Modal .modal-title {
    font-size: 18px;
    font-weight: 600;
}

.find-peoples-sec .search-area h6.count-selected {
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 0px;
    color: #919191;
}

/* Tree chart select & share Modal */

/* Tree Chart video preview Modal */

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-title h5 {
    font-size: 17px;
    margin-bottom: 0px;
    margin-top: 1rem;
}

.tree-preview-vid-Modal .preview-vid .vid-txt>.row {
    align-items: center;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button {
    font-size: 15px;
    color: black;
    padding: 8px 0px;
    border-radius: 6px;
    transition: all 0.2s linear;
    width: 150px;
    border: 1px solid #ccc;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button:hover {
    background-color: #6e5eff;
    color: #ffffff;
}

/* Tree Chart video preview Modal */

/* Tree Chart Publish Video Modal */

.tree-publish-vid-Modal .publish-vid-sec .signup-group {
    position: relative;
    margin-bottom: 15px;
}

.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) label {
    top: 5px;
    left: 0;
}

.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) textarea {
    padding: 15px 10px 10px 10px;
    height: 150px;
    resize: none;
}

.publish-vid-sec .info-radio .select-radio {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 15px;
}

.publish-vid-sec .info-radio .select-radio input {
    opacity: 0;
}

.publish-vid-sec .info-radio .select-radio .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    width: 22px;
    border: 1px solid black;
    border-radius: 50%;
}

.publish-vid-sec .info-radio .select-radio input:checked+.checkmark:before {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    height: 10px;
    width: 10px;
    background-color: #6e5eff;
    border-radius: 50%;
}

.tree-publish-vid-Modal .publish-vid-sec h5 {
    font-size: 17px;
    margin-bottom: 0px;
    margin-top: 1rem;
}

.mat-hint {
    font-size: 0.7rem;
}

.tree-publish-vid-Modal .publish-vid-sec p {
    font-size: 12px;
    color: #605f5f;
}

.tree-publish-vid-Modal .publish-vid-sec select {
    font-size: 14px;
}

.publish-vid .thumbnail-area .row>div {
    padding-left: 5px;
    padding-right: 5px;
}

.publish-vid .thumbnail-area .select-thumb {
    position: relative;
    cursor: pointer;
    height: 60px;
    margin-top: 10px;
}

.publish-vid .thumbnail-area .select-thumb.up {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dotted;
}

.publish-vid .thumbnail-area .select-thumb input {
    display: none;
}

.publish-vid .thumbnail-area .select-thumb .upload img {
    width: 20px;
    height: 20px;
}

.publish-vid .thumbnail-area .select-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.publish-vid .thumbnail-area .select-thumb input:checked~.check {
    width: 100%;
    height: 100%;
    background-color: #6e5effcc;
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.publish-vid .thumbnail-area .select-thumb input:checked~.check:before {
    content: "";
    width: 7px;
    height: 14px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

.publish-vid-btn {
    bottom: 0px;
    right: 16px;
}

.publish-vid-btn button {
    font-size: 15px;
    color: black;
    padding: 8px 0px;
    border-radius: 6px;
    transition: all 0.2s linear;
    width: 140px;
    border: 1px solid #ccc;
}

.publish-vid-btn button:hover {
    background-color: #6e5eff;
    color: #ffffff;
}

/* Tree Chart Publish Video Modal */

.node {
    cursor: pointer;
}

.node circle {
    fill: #fff;
    stroke: steelblue;
    stroke-width: 3px;
}

.node text {
    font: 12px sans-serif;
}

.link {
    fill: none;
    stroke: #ccc;
    stroke-width: 2px;
}

.select-video {
    text-align: left;
    margin: 140px auto 85px;
    width: 350px;
    padding: 33px 22px;
    cursor: pointer;
    border: 1px solid #ccc;
    transition: 0.3s all ease-in-out;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
    background-color: #fff;
}

.select-video svg {
    width: 10%;
    height: 30px;
    margin-right: 5px;
    fill: #5c5c5c;
}

.select-video:hover {
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
    background: #fff;
}

.select-option {
    margin: 140px auto 85px;
    width: 430px;
}

.select-option1 {
    /*margin: 10px auto 0px;*/
    position: relative;
    -webkit-user-select: none;
            user-select: none;
}

.select-option .option-1 {
    text-align: center;
    margin: 0 auto;
    float: left;
    margin-right: 15px;
    padding: 50px 35px;
    cursor: pointer;
    width: 200px;
    border: 1px solid #ccc;
    outline: none;
    transition: 0.3s all ease-in-out;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
    background: transparent;
}

.select-option .option-2 {
    text-align: center;
    margin: 0 auto;
    margin-right: 15px;
    padding: 50px 35px;
    width: 200px;
    outline: none;
    cursor: pointer;
    border: 1px solid #ccc;
    transition: 0.3s all ease-in-out;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
    background: transparent;
}

.select-option .option-2:hover,
.select-option .option-1:hover {
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
    background: #fff;
}

.uploadVideoButton {
    text-align: left;
    padding: 20px;
    margin-top: -66px;
    cursor: pointer;
    width: 350px;
    margin: 0 auto;
    margin-top: -66px;
    background-color: #fff;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
    transition: 0.3s all ease-in-out;
}

.uploadVideoButton:hover {
    text-decoration: none;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
    background: #fff;
}

.create-interactive-button {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    font-size: 15px;
    display: block;
    /*margin: 0 auto;*/
    cursor: pointer;
    position: relative;
    outline: none;
    margin: 4px 0 4px 4px;
}

.chcoice {
    font-size: 14px;
    margin-top: 10px;
}

.infor-msg {
    margin-bottom: 10px;
}

.add-choices input {
    width: 60px;
    display: inline-block;
}

/*.add-choices button {*/
/*  border: 1px solid #6e5eff;*/
/*  padding: 8px 15px 7px;*/
/*  border-radius: 5px;*/
/*  background: #6e5eff;*/
/*  color: #ffff;*/
/*  cursor: pointer;*/
/*  position: relative;*/
/*  display: inline-block;*/
/*  outline: none;*/
/*  border-left: 0;*/
/*  margin: 0 auto 0 10px;*/
/*}*/

.cross-icon {
    width: 10px;
    display: inline-block;
    margin-top: -3px;
    vertical-align: middle;
    margin-right: 3px;
}

.chexk-box-top {
    width: 100%;
    margin: 5px;
}

.delete-btn.btn-after-delet {
    margin-right: 15px;
}

.option-choices {
    margin-bottom: 15px;
}

.option-choices.draggable {
    cursor: move;
    border: 1px dashed #dc3545;
}

.choice-btn {
    border: 1px solid #6e5eff;
    padding: 5px 15px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    display: inline-block;
    cursor: pointer;
    position: relative;
    outline: none;
    border-left: 0;
    height: -moz-fit-content;
    height: fit-content;
    margin: 0 0px 0 4px;
    max-width: 99.2% !important;
}

input.close.leave-btn {
    background: transparent;
    border: none;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    text-align: center;
    width: 100%;
    margin-left: 0px;
}

.nodeTitleInput {
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    padding-bottom: 5px;
    width: 100%;
}

.nodeTitleInput:focus {
    border-bottom: 1px solid #ccc;
}

.ifram-popup {
    width: 100%;
    height: 250px;
}

.tree-view-chart-sec {
    height: calc(100% - 263px);
    overflow: auto;
    /*padding-bottom: 70px;*/
}

.treeContainer {
    /* height: 650px; */
    width: 100%;
    overflow: auto;
}

.tree-card-vid {
    position: relative;
}

/*.tree-card-vid::before {*/
/*  content: "";*/
/*  position: absolute;*/
/*  background: rgba(0, 0, 0, 0.5);*/
/*  top: 0;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  left: 0;*/
/*  height: 32px;*/
/*}*/

/*.tree-card-vid::after {*/
/*  content: "";*/
/*  position: absolute;*/
/*  background: rgba(0, 0, 0, 0.4);*/
/*  top: 0px;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  left: 0;*/
/*  height: 38px;*/
/*}*/

.custom-label h6 {
    width: 100%;
    word-break: break-all;
}

.optionschoiceitem {
    padding: 20px 10px;
    font-size: 16px;
    /* border-radius: 5px; */
    color: #fff;
    /* margin-right: 10px; */
    /* margin-bottom: 10px; */
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    border-right: 1px solid #fff;
    display: table-cell;
    word-break: break-all;
}

.optionschoiceitem:hover {
    color: #726bfa;
}

.select-thumb.active {
    border: 1px solid #6e5eff;
    /* background: #ccc; */
    /*box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.5);*/
    box-shadow: 0px 0px 0px 3px #6e5eff;
}

.vid-timing {
    width: 100%;
}

.optionsOFchoice {
    background: #000;
    z-index: 9;
    position: relative;
    display: table;
    width: 100%;
    text-align: center;
}

.footer-title-input {
    border-top: none;
    border-left: none;
    border-radius: 0;
    border-right: none;
    background-color: transparent;
    color: #ffffff;
}

.footer-title-input:focus {
    background-color: transparent;
    color: #ffffff;
}

.civ-zoom-btn {
    box-shadow: none;
    border: none;
    background: #6e5eff;
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    padding: 5px 13px;
    margin: 5px;
}

/* WC 03312022 */

.sharing-modal-body {
    padding: 15px;
}

.sharing-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
    /* margin-top: 40px; */
    margin-bottom: 40px;
}

.sharing-links li {
    display: inline-block;
    margin-right: 40px;
    cursor: pointer;
}

.user-list-item {
    width: 100%;
    text-align: left;
    margin-right: 30px;
}

.sharing-links li img {
    width: 50px;
    height: 50px;
}

.sharing-links li p {
    font-size: 12px;
    color: #a6a3a3;
}

.follow-share {
    padding: 5px 20px;
    font-size: 14px;
    position: relative;
    margin-bottom: 15px;
    cursor: pointer;
}

.follow-share img {
    border-radius: 50%;
    position: absolute;
    left: 20px;
    top: 0;
    object-fit: cover;
}

.follow-share h5 {
    font-size: 14px;
    padding-left: 60px;
    margin-top: 12px;
}

.follow-share.selected-share:before {
    content: "\\2713";
    display: inline-block;
    color: #fff;
    position: absolute;
    top: 0;
    align-items: center;
    text-align: center;
    left: 20px;
    background: #6e5eff;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 30px;
    z-index: 9;
    opacity: 0.7;
    line-height: 52px;
}

.follow-share.selected-share h5 {
    color: #6e5eff;
}

.custom-footer button.modal-btn {
    background-color: #6e5eff;
    color: #fff;
    border-radius: 4px;
    padding: 5px 15px;
}

.custom-footer button.modal-btn-close {
    background-color: #605f5f;
    color: #fff;
    border-radius: 4px;
    padding: 10px 23px;
}

.follower-name {
    margin-left: 10px;
}

.select-span {
    display: block;
    text-align: left;
    font-size: 13px;
    margin-left: 37px;
    margin-top: -11px;
}

samp {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.dropdownImg {
    width: 100%;
    height: 100px;
}

.dropdownTime {
    position: absolute;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
}

.timer-button {
    background: #6e5eff;
    border-color: #6e5eff;
    color: white;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
}

/* Responsive CSS */

@media (max-width: 991px) {
    .tree-view-chart-sec {
        padding: 0px 26px !important;
    }

    .select-video {
        width: auto !important;
        padding: 20px !important;
    }

    .uploadVideoButton {
        width: auto !important;
        padding: 20px !important;
    }

    .dropdown-menu {
        min-width: 15.4rem !important;
    }
}

.dropdownWidth {
    padding-right: 4px !important;
    padding-left: 4px !important;
}

@media (max-width: 576px) {
    .vid-options {
        margin-top: 10px !important;
    }

    .dropdown-menu {
        min-width: 15.4rem !important;
    }
}

.collabeBody {
    /* position: relative;
      flex: 1 1 auto;
      padding: 1rem; */
    /* WC 04062022
      height: 206px !important;*/
    height: 325px !important;

    /*WC 04062022 - To show the vertical scroll bar */
    overflow-x: hidden;
    overflow-y: scroll;
    /*WC 04062022 - To show the vertical scroll bar */
}

.collabeImg {
    border-radius: 7px;
    width: 30px !important;
    height: 30px !important;
    margin-right: 4px;
    margin-top: -7px;
}

.upload-img {
    width: 65px;
    height: 65px;
    background-color: #9ca9ba;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
}

.select-vid-area {
    border: 1px dotted black;
    border-radius: 10px;
    padding: 28px 15px;
}

.button-style input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    cursor: pointer;
}

.button-style {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    font-size: 15px;
    display: block;
    width: 200px;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
    outline: none;
}

.button-style-dropdown {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    color: #ffff;
    font-size: 15px;
    display: block;
    width: 100%;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
    outline: none;
    background: #6e5eff;
    text-align: center;
}

.button-style-dropdown input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    cursor: pointer;
}

.topBottomBtn {
    position: fixed;
    bottom: 98px;
    right: 0;
    z-index: 12;
    background-color: black;
    color: white;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    font-size: 14px;
    text-align: center;
}

.fa-external-link-alt {
    text-align: center;
    position: absolute;
    top: 41%;
    left: 48%;
    height: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    display: block;
}

.video-duration {
    position: absolute;
    left: 22px;
    top: 25px;
    background: lightgray;
    padding-left: 4px;
    padding-right: 4px;
    color: black;
}

.video {
    width: 100%;
    height: 200px;
}

.video-title {
    position: absolute;
    left: 20px;
    bottom: -18px;
    padding-right: 4px;
    color: black;
    margin: 0px;
    word-break: break-word;
    font: 400 14px/20px Roboto, "Helvetica Neue", sans-serif;
}

.thumbnail-image {
    width: 90% !important;
    height: 181px !important;
    padding: 9px;
    position: relative;
}

/* .fa-text-width {
    margin-bottom: 40px;
}

.fa-scissors {
    margin-bottom: 40px;
}

.fa-tags {
    margin-bottom: 40px;
}

.fa-paint-brush {
    margin-bottom: 40px;
}

.fa-share-alt {
    margin-bottom: 40px;
}

.fa-download {
    margin-bottom: 40px;
}

.icns {
    float: right;
    display: block;
    width: 6%;
    margin-top: 40px;
    cursor: pointer;
} */

.title-center {
    float: none;
    margin-left: 90px;
}

.icns {
    margin-bottom: 20px;
    padding-bottom: 10px;
}

.slider {
    position: absolute;
    bottom: 180px;
    z-index: 9;
    width: 92.5%;
}

.close {
    font-weight: normal !important;
}

/*
::ng-deep .ngx-slider .ngx-slider-pointer:after {
    content: '>';
    width: 8px !important;
    height: 24px !important;
    position: absolute;
    top: 12px;
    left: 12px;
    border-radius: 4px;
    background: #fff;
}
::ng-deep .ngx-slider .ngx-slider-bar {
    left: 0;
    width: 100%;
    height: 9px !important;
    z-index: 1;
    background: #d8e0f3;
    border-radius: 2px;
}
::ng-deep .ngx-slider .ngx-slider-pointer {
    cursor: pointer;
    width: 17px !important;
    height: 47px !important;
    top: -14px;
    background-color: #0db9f0;
    z-index: 3;
    border-radius: 0 !important;
}
::ng-deep .ngx-slider {
    position: relative !important;
    bottom: 6em !important;
    z-index: 12 !important;
}
::ng-deep .ngx-slider .ngx-slider-bubble {
    color: white !important;
}
::ng-deep .ngx-slider-limit{
    display: none !important;
}
::ng-deep .slider-overground{
    height: 0 !important;

}
::ng-deep .custom-slider{
    height: 0 !important;
    padding: 10px !important;
}
::ng-deep .ngx-slider .ngx-slider-pointer:after {
    content: '';
    width: 0px !important;
    height: 8px;
    position: absolute;
    top: 12px;
    left: 12px;
    border-radius: 4px;
    background: #fff;
}
::ng-deep .ngx-slider .ngx-slider-pointer {
    cursor: pointer;
    width: 8px !important;
    height: 38px !important;
    top: -14px;
    background-color: #0db9f0;
    z-index: 3;
    border-radius: 0 !important;
} */

.annotationPosition {
    position: absolute;
    color: #cc2929;
    z-index: 12;
    /* pointer-events: none; */
}

.btn-outline-info {
    margin-left: 5px;
}

.editVideoBtn {
    cursor: pointer;
}

.editing-tool-icons {
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    /* border-bottom: 1px solid rgb(199, 198, 198); */
    padding: 12px 0px;
    position: relative;
    z-index: 0;
}

.below-Edit-item {
    margin-top: 6px;
    padding: 0px 0px;
    box-shadow: 0px 8px 8px -6px rgba(0, 0, 0, 0.5);
}

.editing-tool-icons img {
    z-index: 1200;
}

/* Volume button slider */

.slidecontainer {
    width: 100%;
}

.mySlider {
    -webkit-appearance: none;
    width: 100%;
    height: 3px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.mySlider:hover {
    opacity: 1;
}

.mySlider::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    appearance: none !important;
    width: 4px !important;
    height: 20px !important;
    background: yellow !important;
    cursor: pointer !important;
}

.mySlider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: #04aa6d;
    cursor: pointer;
}

/* slider for draw line width */

.drawSlider {
    -webkit-appearance: none;
    width: 100%;
    height: 3px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.drawSlider:hover {
    opacity: 1;
}

.drawSlider::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    appearance: none !important;
    width: 6px !important;
    height: 20px !important;
    background: purple !important;
    cursor: pointer !important;
}

.drawSlider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: #04aa6d;
    cursor: pointer;
}

.volume-view {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.create-project-btn {
    background: #6e5eff;
    color: white;
    border: none;
    padding: 5px 23px;
    box-shadow: none;
    outline: none;
}

.show-objectives {
    width: 100%;
    height: 40px;
    position: relative;
    margin: 11px 0 0 0;
    background-color: white;
    color: #6c6c6c;
    overflow-wrap: anywhere;
    overflow: auto;
    padding: 0 5px;
}

.canvas-style {
    position: absolute;
    top: 39px;
    z-index: 12;
}

/*::ng-deep .ng5-slider .ng5-slider-pointer {*/
/*  border-radius: 1px !important;*/
/*  background-color: hsl(11deg 100% 62%) !important;*/
/*  width: 23px !important;*/
/*  height: 36px !important;*/
/*  top: -16px !important;*/
/*  outline: none !important;*/
/*}*/

/*::ng-deep .ng5-slider .ng5-slider-bubble {*/
/*  bottom: 2px !important;*/
/*  !* visibility: hidden !important; *!*/
/*}*/

/*::ng-deep .ng5-slider {*/
/*  margin: 16px 0 15px !important;*/
/*}*/

/*::ng-deep .ng5-slider .ng5-slider-pointer:after {*/
/*  top: 8px !important;*/
/*  content: "" !important;*/
/*  background: #6e5eff !important;*/
/*  display: block !important;*/
/*  content: " " !important;*/
/*  background-size: 28px 28px !important;*/
/*  height: 20px !important;*/
/*  width: 20px !important;*/
/*}*/

/*::ng-deep.ng5-slider .ng5-slider-selection {*/
/*  z-index: 2;*/
/*  background: hsl(11deg 100% 62%) !important;*/
/*  border-radius: 2px;*/
/*}*/

/*::ng-deep .ng5-slider .ng5-slider-bar-wrapper {*/
/*  padding-top: 4px !important;*/
/*  height: 37px !important;*/
/*}*/

/*::ng-deep .ng5-slider .ng5-slider-bar {*/
/*  height: 26px !important;*/
/*}*/

/*::ng-deep .ng5-slider .ng5-slider-pointer:after {*/
/*  content: "";*/
/*  width: 11px !important;*/
/*  height: 19px !important;*/
/*  left: 5px !important;*/
/*}*/

.slide-view {
    border: 6px solid #6e5eff;
    position: absolute;
    width: 100%;
    bottom: 30px;
    z-index: 144;
}

::ng-deep .marker {
    display: none !important;
}

.group-select-btn {
    width: 100%;
    background: white;
    border-bottom: 1px solid #cac9c9;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-radius: 0;
    outline: none !important;
    color: black;
    position: relative;
}

.dropdown-menu ul {
    list-style: none;
    padding-left: 0px;
}

.dropdown-menu ul li {
    border-bottom: 1px solid #80808094;
    padding-left: 11px;
    margin-top: 7px;
    color: #605f5f;
    font-size: 12px;
}

.dropdown-menu .form-control {
    margin-top: 11px;
    border-radius: 0;
    padding: 5px;
    outline: none;
}

.dropdown-menu {
    min-width: 22.4rem;
    top: -277px;
}

/* WC 08282022
.dropdown-item {
  padding: 0 !important;
}
*/

.grpText {
    font-size: 16px !important;
    font-weight: 600;
}

.check-input {
    float: right;
    margin-right: 10px;
}

/* Checkbox code */

.round {
    position: relative;
}

.round label {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 18px;
    width: 18px;
    left: 0;
    position: absolute;
    top: -3px;
}

.round label:after {
    border-top: none;
    border-right: none;
    content: "";
    height: 18px;
    width: 18px;
    left: 7px;
    opacity: 0;
    position: absolute;
    top: 8px;
}

.round input[type="checkbox"] {
    visibility: hidden;
}

.dropdown-menus {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
}

.round input[type="checkbox"]:checked+label {
    background-color: #6e5eff;
    border-color: red;
    border: 3px solid #6e5eff;
    height: 18px;
    width: 18px;
}

.round input[type="checkbox"]:checked+label:after {
    opacity: 1;
    border-radius: 50%;
    height: 18px;
    width: 18px;
}

#dropdownMenu2 {
    text-align: left;
}

.second-ul {
    height: 100px;
    overflow: scroll;
}

.first-ul {
    height: 100px;
    overflow: scroll;
}

.dropdown-menu [type="checkbox"] {
    width: 35px;
    height: 15px;
}

.addChoiceDropDown .dropdown-menu{
    min-width: 8.2rem;
    padding: 0 !important;
}
.addChoiceDropDown .dropdown-menu .dropdown-item{
    font-size: 14px;
}

.addChoiceDropDown .dropdown-item:focus,
.addChoiceDropDown .dropdown-item:hover {
    background-color: rgb(241 234 254) !important;
    color: #6c2fbb !important;
}
.addChoiceDropDown .dropdown-item.active, 
.addChoiceDropDown .dropdown-item:active {
    background-color: inherit;
    color: inherit;
}

.privacy-text {
    position: absolute;
    left: 0;
    top: 0px;
}

.searchIcon {
    color: #808080eb;
}

.searchbox {
    display: flex;
    align-items: center;
    border: 1px solid #80808047;
    margin: 4px;
    border-radius: 3px;
}

.follow-search {
    margin: 3px;
    width: 97%;
    font-size: 14px;
    border-radius: 3px;
    border: none;
}

.btn {
    outline: none;
    box-shadow: none;
}

.example-full-width {
    width: 100%;
}

.grabbable {
    cursor: move;
    cursor: grab;
    cursor: -webkit-grab;
}

.grabbable:active {
    cursor: grabbing;
    cursor: -webkit-grabbing;
}

.btn-link {
    font-size: 14px;
}


.add-pathways-container {
    height: 82%;
    width: 460px;
    position: fixed;
    z-index: 99;
    top: 70px;
    right: 5px;
}

.add-pathways-container .path-img {
    border-radius: 13px;
    max-height: 250px;
    width: 100%;
}

.civ-remove {
    background: #d3d3d3;
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 10px;
    border: none;
    border-radius: 0 6px 0 6px;
}

.civ-paths-btn {
    display: inline-flex;
    align-items: center;
    background: rgba(100, 56, 180, 0.05);
    border: 1px solid #6438B4;
    border-radius: 50px;
    font-weight: 500;
    font-size: 14px;
    color: #6438B4;
    padding: 0 16px;
    margin: 5px;
    min-height: 50px;
    position: relative;
}

.civ-paths-btn i {
    display: none;
    cursor: pointer;
    margin-right: -5px;
    margin-left: 5px;
}

.civ-paths-btn:hover i {
    display: inline-block;
}

.civ-message-body {
    display: flex;
}

.civ-message-body.from {
    justify-content: flex-start;
}

.civ-message-body.to {
    justify-content: flex-end;
}

.civ-message {
    display: inline-block;
    border-radius: 1.5rem;
    margin-bottom: 15px;
    padding: 8px 20px;
    position: relative;
    /*font-size: 20px;*/
}

.civ-message-body.to .civ-message {
    background-color: #9b4dca;
    color: #fff;
    margin-left: 100px;
    width: 200px;
}

.civ-message .type-image {
    width: 100px;
}

.civ-message-body.from .civ-message {
    background-color: #E5E4E9;
    color: #363636;
    margin-right: 100px;
}

.civ-message-body.to+.civ-message-body.to,
.civ-message-body.from+.civ-message-body.from {
    margin-top: -10px;
}

.civ-message-suggestion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
}

.civ-message-suggestion .list-group {}

.civ-message-suggestion .list-group-item {
    padding: 0.5rem;
}

.civ-message-suggestion .choice {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
}


.civr-tab {
    width: 100%;

}

.civr-tab .nav-tabs {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    border: none;
}

.civr-tab .nav-tabs .nav-link {
    border: none;
    background: transparent;
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.civr-tab .nav-tabs .nav-link svg {
    fill: #878395;
}

.civr-tab .nav-tabs .nav-link.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.civr-tab .nav-tabs .nav-link.active svg {
    fill: rgba(108, 47, 187, 1);
}


.civr-tab .pro-img {
    width: 50px;
    height: 50px;
    border-radius: 10px;
}

.civr-tab .profile-image {
    width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
    border-radius: 10px;
}

.civr-tab .civr-username {
    margin: 10px;
}

.civr-tab .civr-checkbox {
    display: flex !important;
    align-items: center;
    line-height: 0px;
}

.popup-objective {
    z-index: 1;
    position: absolute;
    background: white;
    padding: 0 7px;
    border-radius: 6px;
    width: -moz-fit-content;
    width: fit-content;
    top: 52px;
    right: 0;
    width: 200px;
    height: 210px;
    overflow: auto;
}

.objective-img {
    height: 48px;
    display: flex;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
}

.popup-objective ul {
    text-align: start;
    padding-left: 25px;
}

.popup-objective li {
    margin-top: 10px;
}

.example-list {
    list-style-type: none;
    padding: 0;
}

.example-list li {
    display: table-cell;
    padding: 4px;
}

.example-container {
    display: flex;
    flex-wrap: wrap;
    min-width: 600px;
    max-width: 900px;
}

.example-box {
    width: 200px;
    height: 200px;
    border: solid 1px #ccc;
    font-size: 30pt;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
    cursor: move;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #fff;
    border-radius: 4px;
    position: relative;
    z-index: 1;
    transition: box-shadow 200ms cubic-bezier(0, 0, 0.2, 1);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.example-box:active {
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
        0 8px 10px 1px rgba(0, 0, 0, 0.14),
        0 3px 14px 2px rgba(0, 0, 0, 0.12);
    opacity: .6;
}

.cdk-drop-list {
    display: flex;
    padding-right: 10px;
    padding-bottom: 10px;
}

.cdk-drag-preview {
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
        0 8px 10px 1px rgba(0, 0, 0, 0.14),
        0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
    opacity: .3;
}

.cdk-drag-animating {
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

button {
    margin-right: 4px;
}

.w-qus {
    width: 3.2rem;
    height: 3.2rem;
}

.cursor {
    cursor: pointer;
}

.userPromptSection{
    padding-right: 25px;
    padding-left: 5px;
}

.userPromptSection input{
    border-bottom: 1px solid #cccccc !important;
}
.contibutorsTabs p{
    margin: 0;
    font-size: 17px;
    cursor: pointer
}
.activeTab{
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}
::ng-deep .cdk-overlay-container:has(.recordSection) .create-video-modal {
    visibility: hidden;
}
@media (max-width: 1034px) {
    .tree-Modal .tree-card-content .check-line input {
        width: 20vw;
    }
}
@media (max-width: 565px) {
    .tree-Modal .tree-card-content .userPromptSection >div:first-child {
       flex-direction: column;
       gap: 0 !important;
       margin-bottom: 10px;
       margin-top: 5px;
       font-size: 15px;
    }
    .tree-Modal .tree-card-content .userPromptSection >div:last-child i {
       vertical-align: bottom;
    }
}
@media (max-width: 434px) {
    .tree-Modal .tree-card-content .chexk-box-top label {
        width: 100%;
        margin-bottom: 6px !important;
        font-size: 15px;
    }
    .tree-Modal .tree-card-content .mat-card-title-group .mat-card-sm-image {
        width: 50px;
        height: 50px;
    }
    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleChoice {
        padding-left: 7px !important;
    }
    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleEdit,
    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleUpload {
        padding-inline: 0 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/createInteractiveVideo/create-video/create-inter-active-video1.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA,gBAAgB;AAChB,qBAAqB;AACrB,IAAI;;AAEJ;IACI,UAAU;IACV,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA,gDAAgD;AAChD,uBAAuB;AACvB,IAAI;;AAEJ,sDAAsD;AACtD,mBAAmB;AACnB,IAAI;;AAEJ,gBAAgB;AAChB,oCAAoC;AACpC,mCAAmC;AACnC,IAAI;;AAEJ;;;;;;;GAOG;;AAEH,WAAW;AACX,wDAAwD;AACxD,4BAA4B;AAC5B,iCAAiC;AACjC,0BAA0B;AAC1B,kBAAkB;AAClB,qBAAqB;AACrB,IAAI;AACJ,oBAAoB;;AAEpB,0DAA0D;AAC1D,sCAAsC;AACtC,qBAAqB;AACrB,uBAAuB;AACvB,IAAI;;AAEJ,6DAA6D;AAC7D,wBAAwB;AACxB,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd,eAAe;AACf,wCAAwC;AACxC,yCAAyC;AACzC,uCAAuC;AACvC,IAAI;;AAEJ;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA,oCAAoC;;AAEpC;;;IAGI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;;;;;;IAMI,4BAA4B;AAChC;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA,oCAAoC;;AAEpC,mCAAmC;;AAEnC;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,mCAAmC;;AAEnC,mCAAmC;;AAEnC;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,mCAAmC;;AAEnC;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,gCAAgC;IAChC,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;;IAEI,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,8CAA8C;IAC9C,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB,+BAA+B;AAC/B,2BAA2B;AAC3B,wBAAwB;AACxB,yBAAyB;AACzB,kBAAkB;AAClB,qBAAqB;AACrB,wBAAwB;AACxB,2BAA2B;AAC3B,mBAAmB;AACnB,oBAAoB;AACpB,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,wBAAmB;IAAnB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B,iBAAiB;AACjB,wBAAwB;AACxB,oCAAoC;AACpC,YAAY;AACZ,cAAc;AACd,eAAe;AACf,aAAa;AACb,kBAAkB;AAClB,IAAI;;AAEJ,0BAA0B;AAC1B,iBAAiB;AACjB,wBAAwB;AACxB,oCAAoC;AACpC,cAAc;AACd,cAAc;AACd,eAAe;AACf,aAAa;AACb,kBAAkB;AAClB,IAAI;;AAEJ;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,wBAAwB;IACxB,yBAAyB;IACzB,8CAA8C;IAC9C,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kDAAkD;IAClD,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;;0EAEsE;AAC1E;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,mBAAmB;;AAEnB;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;;sBAEkB;IAClB;gCAC4B;IAC5B,wBAAwB;;IAExB,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,WAAW;IACX,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;;AAEH;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiEG;;AAEH;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,iDAAiD;IACjD,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;IACI,aAAa;AACjB;;AAEA,yBAAyB;;AAEzB;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,YAAY;IAEZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,+BAA+B;;AAE/B;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,YAAY;IAEZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA,8CAA8C;AAC9C,mCAAmC;AACnC,sDAAsD;AACtD,4BAA4B;AAC5B,6BAA6B;AAC7B,2BAA2B;AAC3B,8BAA8B;AAC9B,IAAI;;AAEJ,6CAA6C;AAC7C,4BAA4B;AAC5B,yCAAyC;AACzC,IAAI;;AAEJ,0BAA0B;AAC1B,oCAAoC;AACpC,IAAI;;AAEJ,oDAAoD;AACpD,yBAAyB;AACzB,4BAA4B;AAC5B,oCAAoC;AACpC,+BAA+B;AAC/B,6BAA6B;AAC7B,2CAA2C;AAC3C,6BAA6B;AAC7B,4BAA4B;AAC5B,IAAI;;AAEJ,+CAA+C;AAC/C,gBAAgB;AAChB,gDAAgD;AAChD,wBAAwB;AACxB,IAAI;;AAEJ,kDAAkD;AAClD,iCAAiC;AACjC,6BAA6B;AAC7B,IAAI;;AAEJ,0CAA0C;AAC1C,6BAA6B;AAC7B,IAAI;;AAEJ,oDAAoD;AACpD,iBAAiB;AACjB,4BAA4B;AAC5B,6BAA6B;AAC7B,0BAA0B;AAC1B,IAAI;;AAEJ;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;;CAIC;;AAED;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA,kBAAkB;;AAElB;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;;AAEA;;IAEI,6CAA6C;IAC7C,yBAAyB;AAC7B;AACA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IAEZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAEhB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,qCAAqC;;AAErC;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,uDAAuD;IACvD;;uCAEmC;AACvC;;AAEA;IACI;;0CAEsC;IACtC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;;0CAEsC;AAC1C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;AACA;IACI,SAAS;IACT,eAAe;IACf;AACJ;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;OACG,sBAAsB;OACtB,iBAAiB;OACjB,mBAAmB;OACnB,eAAe;OACf,eAAe;IAClB;IACA;OACG,sBAAsB;IACzB;AACJ;AACA;IACI;QACI,WAAW;QACX,6BAA6B;QAC7B,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,4BAA4B;IAChC;IACA;;QAEI,4BAA4B;IAChC;AACJ","sourcesContent":[".tree-view-chart-sec button>.tree-card .card-title {\n    font-size: 18px;\n    margin-bottom: 0px;\n    text-align: left;\n}\n\n.tree-view-chart-sec button>.tree-card {\n    max-width: 400px;\n    box-shadow: 0px 10px 20px -10px #dad8d8;\n}\n\n/* .tree-Modal .modal-dialog {\n    max-width: calc(100% - 5rem) !important;\n} */\n\n.tree-Modal .tree-card-content .vid-select select {\n    width: 100%;\n    border-bottom: 1px solid #5c5c5c;\n    border-radius: 0;\n    margin-bottom: 10px;\n    font-size: 15px;\n}\n\n.pathways-colors {\n    margin: 0px 5px 10px;\n    width: 60px;\n    height: 30px;\n    border-radius: 10px;\n}\n\n.tree-Modal .tree-card-content .opts-row button img {\n    width: 20px;\n    height: 20px;\n}\n\n.url{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.preview-image-none {\n    font-size: 22px;\n    background: #e1e1e1;\n    height: 300px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.preview-image {\n    width: 100%;\n    height: auto;\n    max-height: 300px;\n    cursor: pointer;\n    object-fit: contain;\n}\n\n.publish-vid .thumbnail-area .select-thumb img.deletrThumnails {\n    width: 30px;\n    height: auto;\n    /* margin-top: -43px; */\n    text-align: center;\n    margin-top: 5px;\n    padding: 5px;\n}\n\n.publish-vid .thumbnail-area .select-thumb img.deletrThumnails:hover {\n    background: #ccc;\n}\n\n.tree-Modal .tree-card-vid .leave-btn,\n.tree-Modal .tree-card-vid .more-btn {\n    position: absolute;\n    top: 8px;\n    z-index: 99;\n}\n\n/*.video-card {*/\n/*  cursor: pointer;*/\n/*}*/\n\n.tree-Modal .tree-card-vid .leave-btn {\n    left: 14px;\n    color: #ffffff;\n    opacity: 1;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.tree-Modal .tree-card-vid .more-btn {\n    right: 8px;\n}\n\n.civ-message .msg-description {\n    overflow-wrap: anywhere;\n}\n\n\n.objectives {\n    width: 300px;\n    position: relative;\n    margin: 11px 0 0 0;\n}\n\n.objectives input {\n    margin: 0px;\n    padding: 0px;\n    width: 100%;\n    outline: none;\n    height: 40px;\n    border-radius: 5px;\n    border: none;\n    padding: 0 0 0 5px;\n}\n\n.objectives button {\n    position: absolute;\n    top: 0;\n    right: -2px;\n    z-index: 2;\n    border: none;\n    top: 0;\n    height: 40px;\n    cursor: pointer;\n    transform: translateX(2px);\n    width: 36px;\n}\n\n.objectives i {\n    font-size: 18px;\n    line-height: 2;\n    color: #6c6c6c;\n}\n\n.objectImg img {\n    height: 40px;\n}\n\n.objectImg span i {\n    font-size: 18px;\n    cursor: pointer;\n    color: #6c6c6c;\n}\n\n.objectivesButtons .btnDone {\n    background: #9b4dca;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n.objectivesButtons .btnCancel {\n    background: #6c6c6c;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n/*.tree-Modal .tree-card-vid .more-btn button {*/\n/*  padding: 0px 10px;*/\n/*}*/\n\n/*.tree-Modal .tree-card-vid .more-btn button:after {*/\n/*  display: none;*/\n/*}*/\n\n/*.tree-Modal {*/\n/*  padding-right: 15px !important;*/\n/*  padding-left: 15px !important;*/\n/*}*/\n\n/* WC 08282022\n/* ORIGINAL\n.tree-Modal .tree-card-vid .more-btn .dropdown-menu {\n  left: -126px !important;\n  transform: unset !important;\n  top: 25px !important;\n  padding: 0px;\n} */\n\n/* UPDATE */\n/*.tree-Modal .tree-card-vid .more-btn .dropdown-menu {*/\n/*  left: -25px !important;*/\n/*  transform: unset !important;*/\n/*  top: 25px !important;*/\n/*  padding: 0px;*/\n/*  min-width: auto;*/\n/*}*/\n/*!* WC 08282022 *!*/\n\n/*.tree-Modal .tree-card-vid .more-btn .dropdown-menu a {*/\n/*  border-bottom: 1px solid #5c5c5c;*/\n/*  font-size: 15px;*/\n/*  padding: 8px 12px;*/\n/*}*/\n\n/*.tree-Modal .tree-card-vid .more-btn .dropdown-menu span {*/\n/*  position: absolute;*/\n/*  top: -6px;*/\n/*  right: 6px;*/\n/*  width: 0;*/\n/*  height: 0;*/\n/*  border-left: 8px solid transparent;*/\n/*  border-right: 8px solid transparent;*/\n/*  border-bottom: 10px solid #ffffff;*/\n/*}*/\n\n.tree-Modal .tree-card-content .check-line span {\n    width: 20px;\n    height: 20px;\n    border: 1px solid black;\n    display: inline-block;\n    margin-right: 8px;\n}\n\n.tree-Modal .tree-card-content .check-line input {\n    color: #000;\n    margin-left: 10px;\n    border: 0px;\n    width: 6vw;\n    border-bottom: 1px solid #ccc;\n    font: 400 14px/20px Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.tree-Modal .tree-card-content .check-line label {\n    cursor: pointer;\n    font-size: 15px;\n}\n\n.tree-Modal .tree-card-content .check-line input:checked+label:after {\n    content: \"\";\n    position: absolute;\n    left: 22px;\n    top: 5px;\n    width: 6px;\n    height: 14px;\n    border: solid #6e5eff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.tree-Modal .tree-card-vid video {\n    outline: none;\n}\n\n.find-peoples-sec .search-area .share-btn {\n    width: 100%;\n    background: #6e5eff;\n    color: #ffffff;\n}\n\n.find-peoples-sec .search-area .search button {\n    position: absolute;\n}\n\n.find-peoples-sec .search-area .search input {\n    padding-left: 40px;\n    font-size: 15px;\n}\n\n.FF-scroll-modify {\n    max-height: 360px;\n    height: auto;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\ntextarea::-webkit-scrollbar {\n    width: 6px;\n}\n\ntextarea::-webkit-scrollbar-track {\n    background: transparent;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n    background: #ebebed;\n    border-radius: 50px;\n}\n\ntextarea::-webkit-scrollbar-thumb:hover {\n    background: #d9d9db;\n}\n\n#vid-search-btn {\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 9;\n}\n\n.checknbox input {\n    width: 18px;\n    height: 18px;\n    margin-top: 37px;\n}\n\n.checknbox label {\n    display: block;\n    margin: 0;\n    height: 100%;\n    text-align: center;\n    cursor: pointer;\n    width: 100%;\n}\n\n.custom-label {\n    display: block;\n    margin: 0;\n    width: 100%;\n    text-align: center;\n    cursor: pointer;\n}\n\n.symbol-class {\n    height: 40px;\n    margin-right: 5px;\n}\n\n.selected-item {\n    background-color: #ccc;\n    padding: 0px 21px;\n    height: 224px;\n}\n\n.find-peoples-sec .select-area .FF-scroll-modify {\n    height: 133px;\n}\n\n.find-peoples-sec .select-area .form-check {\n    margin-bottom: 14px;\n}\n\n.find-peoples-sec .select-area .form-check span {\n    display: inline-block;\n    width: 35px;\n    height: 35px;\n    border: 1px solid #e6e3e3;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.find-peoples-sec .select-area .form-check input {\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n    margin-left: 0px;\n}\n\n.find-peoples-sec .select-area .form-check span img {\n    width: 100%;\n    height: 100%;\n}\n\n.find-peoples-sec .select-area .form-check input:checked+label {\n    color: #6e5eff;\n}\n\n.find-peoples-sec .select-area .form-check input:checked+label:after {\n    content: \"\";\n    position: absolute;\n    left: 13px;\n    top: 8px;\n    width: 10px;\n    height: 17px;\n    border: solid #ffffff;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n}\n\n.find-peoples-sec .select-area .form-check input:checked+label:before {\n    content: \"\";\n    width: 35px;\n    height: 35px;\n    background-color: #6e5effcc;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    border-radius: 50%;\n}\n\n/* Tree chart select & share Modal */\n\n.tree-share-Modal,\n.tree-preview-vid-Modal,\n.tree-publish-vid-Modal {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n}\n\n.tree-share-Modal .modal-body,\n.tree-share-Modal .modal-header,\n.tree-preview-vid-Modal .modal-body,\n.tree-preview-vid-Modal .modal-header,\n.tree-publish-vid-Modal .modal-body,\n.tree-publish-vid-Modal .modal-header {\n    padding: 20px 25px 25px 25px;\n}\n\n.tree-share-Modal .modal-title,\n.tree-preview-vid-Modal .modal-title,\n.tree-publish-vid-Modal .modal-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.find-peoples-sec .search-area h6.count-selected {\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 0px;\n    color: #919191;\n}\n\n/* Tree chart select & share Modal */\n\n/* Tree Chart video preview Modal */\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-title h5 {\n    font-size: 17px;\n    margin-bottom: 0px;\n    margin-top: 1rem;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt>.row {\n    align-items: center;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button {\n    font-size: 15px;\n    color: black;\n    padding: 8px 0px;\n    border-radius: 6px;\n    transition: all 0.2s linear;\n    width: 150px;\n    border: 1px solid #ccc;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button:hover {\n    background-color: #6e5eff;\n    color: #ffffff;\n}\n\n/* Tree Chart video preview Modal */\n\n/* Tree Chart Publish Video Modal */\n\n.tree-publish-vid-Modal .publish-vid-sec .signup-group {\n    position: relative;\n    margin-bottom: 15px;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) label {\n    top: 5px;\n    left: 0;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec .signup-group:nth-child(2) textarea {\n    padding: 15px 10px 10px 10px;\n    height: 150px;\n    resize: none;\n}\n\n.publish-vid-sec .info-radio .select-radio {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 15px;\n}\n\n.publish-vid-sec .info-radio .select-radio input {\n    opacity: 0;\n}\n\n.publish-vid-sec .info-radio .select-radio .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 22px;\n    width: 22px;\n    border: 1px solid black;\n    border-radius: 50%;\n}\n\n.publish-vid-sec .info-radio .select-radio input:checked+.checkmark:before {\n    content: \"\";\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    height: 10px;\n    width: 10px;\n    background-color: #6e5eff;\n    border-radius: 50%;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec h5 {\n    font-size: 17px;\n    margin-bottom: 0px;\n    margin-top: 1rem;\n}\n\n.mat-hint {\n    font-size: 0.7rem;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec p {\n    font-size: 12px;\n    color: #605f5f;\n}\n\n.tree-publish-vid-Modal .publish-vid-sec select {\n    font-size: 14px;\n}\n\n.publish-vid .thumbnail-area .row>div {\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.publish-vid .thumbnail-area .select-thumb {\n    position: relative;\n    cursor: pointer;\n    height: 60px;\n    margin-top: 10px;\n}\n\n.publish-vid .thumbnail-area .select-thumb.up {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px dotted;\n}\n\n.publish-vid .thumbnail-area .select-thumb input {\n    display: none;\n}\n\n.publish-vid .thumbnail-area .select-thumb .upload img {\n    width: 20px;\n    height: 20px;\n}\n\n.publish-vid .thumbnail-area .select-thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.publish-vid .thumbnail-area .select-thumb input:checked~.check {\n    width: 100%;\n    height: 100%;\n    background-color: #6e5effcc;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.publish-vid .thumbnail-area .select-thumb input:checked~.check:before {\n    content: \"\";\n    width: 7px;\n    height: 14px;\n    border: solid #ffffff;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n}\n\n.publish-vid-btn {\n    bottom: 0px;\n    right: 16px;\n}\n\n.publish-vid-btn button {\n    font-size: 15px;\n    color: black;\n    padding: 8px 0px;\n    border-radius: 6px;\n    transition: all 0.2s linear;\n    width: 140px;\n    border: 1px solid #ccc;\n}\n\n.publish-vid-btn button:hover {\n    background-color: #6e5eff;\n    color: #ffffff;\n}\n\n/* Tree Chart Publish Video Modal */\n\n.node {\n    cursor: pointer;\n}\n\n.node circle {\n    fill: #fff;\n    stroke: steelblue;\n    stroke-width: 3px;\n}\n\n.node text {\n    font: 12px sans-serif;\n}\n\n.link {\n    fill: none;\n    stroke: #ccc;\n    stroke-width: 2px;\n}\n\n.select-video {\n    text-align: left;\n    margin: 140px auto 85px;\n    width: 350px;\n    padding: 33px 22px;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    transition: 0.3s all ease-in-out;\n    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n    background-color: #fff;\n}\n\n.select-video svg {\n    width: 10%;\n    height: 30px;\n    margin-right: 5px;\n    fill: #5c5c5c;\n}\n\n.select-video:hover {\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);\n    background: #fff;\n}\n\n.select-option {\n    margin: 140px auto 85px;\n    width: 430px;\n}\n\n.select-option1 {\n    /*margin: 10px auto 0px;*/\n    position: relative;\n    user-select: none;\n}\n\n.select-option .option-1 {\n    text-align: center;\n    margin: 0 auto;\n    float: left;\n    margin-right: 15px;\n    padding: 50px 35px;\n    cursor: pointer;\n    width: 200px;\n    border: 1px solid #ccc;\n    outline: none;\n    transition: 0.3s all ease-in-out;\n    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n    background: transparent;\n}\n\n.select-option .option-2 {\n    text-align: center;\n    margin: 0 auto;\n    margin-right: 15px;\n    padding: 50px 35px;\n    width: 200px;\n    outline: none;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    transition: 0.3s all ease-in-out;\n    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n    background: transparent;\n}\n\n.select-option .option-2:hover,\n.select-option .option-1:hover {\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);\n    background: #fff;\n}\n\n.uploadVideoButton {\n    text-align: left;\n    padding: 20px;\n    margin-top: -66px;\n    cursor: pointer;\n    width: 350px;\n    margin: 0 auto;\n    margin-top: -66px;\n    background-color: #fff;\n    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n    transition: 0.3s all ease-in-out;\n}\n\n.uploadVideoButton:hover {\n    text-decoration: none;\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);\n    background: #fff;\n}\n\n.create-interactive-button {\n    border: 1px solid #6e5eff;\n    padding: 8px 30px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    font-size: 15px;\n    display: block;\n    /*margin: 0 auto;*/\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    margin: 4px 0 4px 4px;\n}\n\n.chcoice {\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n.infor-msg {\n    margin-bottom: 10px;\n}\n\n.add-choices input {\n    width: 60px;\n    display: inline-block;\n}\n\n/*.add-choices button {*/\n/*  border: 1px solid #6e5eff;*/\n/*  padding: 8px 15px 7px;*/\n/*  border-radius: 5px;*/\n/*  background: #6e5eff;*/\n/*  color: #ffff;*/\n/*  cursor: pointer;*/\n/*  position: relative;*/\n/*  display: inline-block;*/\n/*  outline: none;*/\n/*  border-left: 0;*/\n/*  margin: 0 auto 0 10px;*/\n/*}*/\n\n.cross-icon {\n    width: 10px;\n    display: inline-block;\n    margin-top: -3px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.chexk-box-top {\n    width: 100%;\n    margin: 5px;\n}\n\n.delete-btn.btn-after-delet {\n    margin-right: 15px;\n}\n\n.option-choices {\n    margin-bottom: 15px;\n}\n\n.option-choices.draggable {\n    cursor: move;\n    border: 1px dashed #dc3545;\n}\n\n.choice-btn {\n    border: 1px solid #6e5eff;\n    padding: 5px 15px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    display: inline-block;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    border-left: 0;\n    height: fit-content;\n    margin: 0 0px 0 4px;\n    max-width: 99.2% !important;\n}\n\ninput.close.leave-btn {\n    background: transparent;\n    border: none;\n    padding-bottom: 5px;\n    border-bottom: 1px solid #ccc;\n    text-align: center;\n    width: 100%;\n    margin-left: 0px;\n}\n\n.nodeTitleInput {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid transparent;\n    outline: none;\n    padding-bottom: 5px;\n    width: 100%;\n}\n\n.nodeTitleInput:focus {\n    border-bottom: 1px solid #ccc;\n}\n\n.ifram-popup {\n    width: 100%;\n    height: 250px;\n}\n\n.tree-view-chart-sec {\n    height: calc(100% - 263px);\n    overflow: auto;\n    /*padding-bottom: 70px;*/\n}\n\n.treeContainer {\n    /* height: 650px; */\n    width: 100%;\n    overflow: auto;\n}\n\n.tree-card-vid {\n    position: relative;\n}\n\n/*.tree-card-vid::before {*/\n/*  content: \"\";*/\n/*  position: absolute;*/\n/*  background: rgba(0, 0, 0, 0.5);*/\n/*  top: 0;*/\n/*  right: 0;*/\n/*  bottom: 0;*/\n/*  left: 0;*/\n/*  height: 32px;*/\n/*}*/\n\n/*.tree-card-vid::after {*/\n/*  content: \"\";*/\n/*  position: absolute;*/\n/*  background: rgba(0, 0, 0, 0.4);*/\n/*  top: 0px;*/\n/*  right: 0;*/\n/*  bottom: 0;*/\n/*  left: 0;*/\n/*  height: 38px;*/\n/*}*/\n\n.custom-label h6 {\n    width: 100%;\n    word-break: break-all;\n}\n\n.optionschoiceitem {\n    padding: 20px 10px;\n    font-size: 16px;\n    /* border-radius: 5px; */\n    color: #fff;\n    /* margin-right: 10px; */\n    /* margin-bottom: 10px; */\n    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);\n    cursor: pointer;\n    border-right: 1px solid #fff;\n    display: table-cell;\n    word-break: break-all;\n}\n\n.optionschoiceitem:hover {\n    color: #726bfa;\n}\n\n.select-thumb.active {\n    border: 1px solid #6e5eff;\n    /* background: #ccc; */\n    /*box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.5);*/\n    box-shadow: 0px 0px 0px 3px #6e5eff;\n}\n\n.vid-timing {\n    width: 100%;\n}\n\n.optionsOFchoice {\n    background: #000;\n    z-index: 9;\n    position: relative;\n    display: table;\n    width: 100%;\n    text-align: center;\n}\n\n.footer-title-input {\n    border-top: none;\n    border-left: none;\n    border-radius: 0;\n    border-right: none;\n    background-color: transparent;\n    color: #ffffff;\n}\n\n.footer-title-input:focus {\n    background-color: transparent;\n    color: #ffffff;\n}\n\n.civ-zoom-btn {\n    box-shadow: none;\n    border: none;\n    background: #6e5eff;\n    color: #fff;\n    border-radius: 5px;\n    font-size: 16px;\n    padding: 5px 13px;\n    margin: 5px;\n}\n\n/* WC 03312022 */\n\n.sharing-modal-body {\n    padding: 15px;\n}\n\n.sharing-links {\n    list-style-type: none;\n    padding: 0;\n    text-align: center;\n    /* margin-top: 40px; */\n    margin-bottom: 40px;\n}\n\n.sharing-links li {\n    display: inline-block;\n    margin-right: 40px;\n    cursor: pointer;\n}\n\n.user-list-item {\n    width: 100%;\n    text-align: left;\n    margin-right: 30px;\n}\n\n.sharing-links li img {\n    width: 50px;\n    height: 50px;\n}\n\n.sharing-links li p {\n    font-size: 12px;\n    color: #a6a3a3;\n}\n\n.follow-share {\n    padding: 5px 20px;\n    font-size: 14px;\n    position: relative;\n    margin-bottom: 15px;\n    cursor: pointer;\n}\n\n.follow-share img {\n    border-radius: 50%;\n    position: absolute;\n    left: 20px;\n    top: 0;\n    object-fit: cover;\n}\n\n.follow-share h5 {\n    font-size: 14px;\n    padding-left: 60px;\n    margin-top: 12px;\n}\n\n.follow-share.selected-share:before {\n    content: \"\\2713\";\n    display: inline-block;\n    color: #fff;\n    position: absolute;\n    top: 0;\n    align-items: center;\n    text-align: center;\n    left: 20px;\n    background: #6e5eff;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    font-size: 30px;\n    z-index: 9;\n    opacity: 0.7;\n    line-height: 52px;\n}\n\n.follow-share.selected-share h5 {\n    color: #6e5eff;\n}\n\n.custom-footer button.modal-btn {\n    background-color: #6e5eff;\n    color: #fff;\n    border-radius: 4px;\n    padding: 5px 15px;\n}\n\n.custom-footer button.modal-btn-close {\n    background-color: #605f5f;\n    color: #fff;\n    border-radius: 4px;\n    padding: 10px 23px;\n}\n\n.follower-name {\n    margin-left: 10px;\n}\n\n.select-span {\n    display: block;\n    text-align: left;\n    font-size: 13px;\n    margin-left: 37px;\n    margin-top: -11px;\n}\n\nsamp {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n        \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n        \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n}\n\n.dropdownImg {\n    width: 100%;\n    height: 100px;\n}\n\n.dropdownTime {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n}\n\n.timer-button {\n    background: #6e5eff;\n    border-color: #6e5eff;\n    color: white;\n    padding: 8px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n/* Responsive CSS */\n\n@media (max-width: 991px) {\n    .tree-view-chart-sec {\n        padding: 0px 26px !important;\n    }\n\n    .select-video {\n        width: auto !important;\n        padding: 20px !important;\n    }\n\n    .uploadVideoButton {\n        width: auto !important;\n        padding: 20px !important;\n    }\n\n    .dropdown-menu {\n        min-width: 15.4rem !important;\n    }\n}\n\n.dropdownWidth {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n}\n\n@media (max-width: 576px) {\n    .vid-options {\n        margin-top: 10px !important;\n    }\n\n    .dropdown-menu {\n        min-width: 15.4rem !important;\n    }\n}\n\n.collabeBody {\n    /* position: relative;\n      flex: 1 1 auto;\n      padding: 1rem; */\n    /* WC 04062022\n      height: 206px !important;*/\n    height: 325px !important;\n\n    /*WC 04062022 - To show the vertical scroll bar */\n    overflow-x: hidden;\n    overflow-y: scroll;\n    /*WC 04062022 - To show the vertical scroll bar */\n}\n\n.collabeImg {\n    border-radius: 7px;\n    width: 30px !important;\n    height: 30px !important;\n    margin-right: 4px;\n    margin-top: -7px;\n}\n\n.upload-img {\n    width: 65px;\n    height: 65px;\n    background-color: #9ca9ba;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 15px;\n}\n\n.select-vid-area {\n    border: 1px dotted black;\n    border-radius: 10px;\n    padding: 28px 15px;\n}\n\n.button-style input {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9;\n    cursor: pointer;\n}\n\n.button-style {\n    border: 1px solid #6e5eff;\n    padding: 8px 30px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    font-size: 15px;\n    display: block;\n    width: 200px;\n    margin: 0 auto;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n}\n\n.button-style-dropdown {\n    border: 1px solid #6e5eff;\n    padding: 8px 30px;\n    border-radius: 5px;\n    color: #ffff;\n    font-size: 15px;\n    display: block;\n    width: 100%;\n    margin: 0 auto;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    background: #6e5eff;\n    text-align: center;\n}\n\n.button-style-dropdown input {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9;\n    cursor: pointer;\n}\n\n.topBottomBtn {\n    position: fixed;\n    bottom: 98px;\n    right: 0;\n    z-index: 12;\n    background-color: black;\n    color: white;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    font-size: 14px;\n    text-align: center;\n}\n\n.fa-external-link-alt {\n    text-align: center;\n    position: absolute;\n    top: 41%;\n    left: 48%;\n    height: 50%;\n    transform: translate(-50%, -50%);\n    width: 10px;\n    height: 10px;\n    display: block;\n}\n\n.video-duration {\n    position: absolute;\n    left: 22px;\n    top: 25px;\n    background: lightgray;\n    padding-left: 4px;\n    padding-right: 4px;\n    color: black;\n}\n\n.video {\n    width: 100%;\n    height: 200px;\n}\n\n.video-title {\n    position: absolute;\n    left: 20px;\n    bottom: -18px;\n    padding-right: 4px;\n    color: black;\n    margin: 0px;\n    word-break: break-word;\n    font: 400 14px/20px Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.thumbnail-image {\n    width: 90% !important;\n    height: 181px !important;\n    padding: 9px;\n    position: relative;\n}\n\n/* .fa-text-width {\n    margin-bottom: 40px;\n}\n\n.fa-scissors {\n    margin-bottom: 40px;\n}\n\n.fa-tags {\n    margin-bottom: 40px;\n}\n\n.fa-paint-brush {\n    margin-bottom: 40px;\n}\n\n.fa-share-alt {\n    margin-bottom: 40px;\n}\n\n.fa-download {\n    margin-bottom: 40px;\n}\n\n.icns {\n    float: right;\n    display: block;\n    width: 6%;\n    margin-top: 40px;\n    cursor: pointer;\n} */\n\n.title-center {\n    float: none;\n    margin-left: 90px;\n}\n\n.icns {\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n}\n\n.slider {\n    position: absolute;\n    bottom: 180px;\n    z-index: 9;\n    width: 92.5%;\n}\n\n.close {\n    font-weight: normal !important;\n}\n\n/*\n::ng-deep .ngx-slider .ngx-slider-pointer:after {\n    content: '>';\n    width: 8px !important;\n    height: 24px !important;\n    position: absolute;\n    top: 12px;\n    left: 12px;\n    border-radius: 4px;\n    background: #fff;\n}\n::ng-deep .ngx-slider .ngx-slider-bar {\n    left: 0;\n    width: 100%;\n    height: 9px !important;\n    z-index: 1;\n    background: #d8e0f3;\n    border-radius: 2px;\n}\n::ng-deep .ngx-slider .ngx-slider-pointer {\n    cursor: pointer;\n    width: 17px !important;\n    height: 47px !important;\n    top: -14px;\n    background-color: #0db9f0;\n    z-index: 3;\n    border-radius: 0 !important;\n}\n::ng-deep .ngx-slider {\n    position: relative !important;\n    bottom: 6em !important;\n    z-index: 12 !important;\n}\n::ng-deep .ngx-slider .ngx-slider-bubble {\n    color: white !important;\n}\n::ng-deep .ngx-slider-limit{\n    display: none !important;\n}\n::ng-deep .slider-overground{\n    height: 0 !important;\n\n}\n::ng-deep .custom-slider{\n    height: 0 !important;\n    padding: 10px !important;\n}\n::ng-deep .ngx-slider .ngx-slider-pointer:after {\n    content: '';\n    width: 0px !important;\n    height: 8px;\n    position: absolute;\n    top: 12px;\n    left: 12px;\n    border-radius: 4px;\n    background: #fff;\n}\n::ng-deep .ngx-slider .ngx-slider-pointer {\n    cursor: pointer;\n    width: 8px !important;\n    height: 38px !important;\n    top: -14px;\n    background-color: #0db9f0;\n    z-index: 3;\n    border-radius: 0 !important;\n} */\n\n.annotationPosition {\n    position: absolute;\n    color: #cc2929;\n    z-index: 12;\n    /* pointer-events: none; */\n}\n\n.btn-outline-info {\n    margin-left: 5px;\n}\n\n.editVideoBtn {\n    cursor: pointer;\n}\n\n.editing-tool-icons {\n    display: flex;\n    justify-content: space-around;\n    cursor: pointer;\n    /* border-bottom: 1px solid rgb(199, 198, 198); */\n    padding: 12px 0px;\n    position: relative;\n    z-index: 0;\n}\n\n.below-Edit-item {\n    margin-top: 6px;\n    padding: 0px 0px;\n    box-shadow: 0px 8px 8px -6px rgba(0, 0, 0, 0.5);\n}\n\n.editing-tool-icons img {\n    z-index: 1200;\n}\n\n/* Volume button slider */\n\n.slidecontainer {\n    width: 100%;\n}\n\n.mySlider {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 3px;\n    background: #d3d3d3;\n    outline: none;\n    opacity: 0.7;\n    -webkit-transition: 0.2s;\n    transition: opacity 0.2s;\n}\n\n.mySlider:hover {\n    opacity: 1;\n}\n\n.mySlider::-webkit-slider-thumb {\n    -webkit-appearance: none !important;\n    appearance: none !important;\n    width: 4px !important;\n    height: 20px !important;\n    background: yellow !important;\n    cursor: pointer !important;\n}\n\n.mySlider::-moz-range-thumb {\n    width: 25px;\n    height: 25px;\n    background: #04aa6d;\n    cursor: pointer;\n}\n\n/* slider for draw line width */\n\n.drawSlider {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 3px;\n    background: #d3d3d3;\n    outline: none;\n    opacity: 0.7;\n    -webkit-transition: 0.2s;\n    transition: opacity 0.2s;\n}\n\n.drawSlider:hover {\n    opacity: 1;\n}\n\n.drawSlider::-webkit-slider-thumb {\n    -webkit-appearance: none !important;\n    appearance: none !important;\n    width: 6px !important;\n    height: 20px !important;\n    background: purple !important;\n    cursor: pointer !important;\n}\n\n.drawSlider::-moz-range-thumb {\n    width: 25px;\n    height: 25px;\n    background: #04aa6d;\n    cursor: pointer;\n}\n\n.volume-view {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.create-project-btn {\n    background: #6e5eff;\n    color: white;\n    border: none;\n    padding: 5px 23px;\n    box-shadow: none;\n    outline: none;\n}\n\n.show-objectives {\n    width: 100%;\n    height: 40px;\n    position: relative;\n    margin: 11px 0 0 0;\n    background-color: white;\n    color: #6c6c6c;\n    overflow-wrap: anywhere;\n    overflow: auto;\n    padding: 0 5px;\n}\n\n.canvas-style {\n    position: absolute;\n    top: 39px;\n    z-index: 12;\n}\n\n/*::ng-deep .ng5-slider .ng5-slider-pointer {*/\n/*  border-radius: 1px !important;*/\n/*  background-color: hsl(11deg 100% 62%) !important;*/\n/*  width: 23px !important;*/\n/*  height: 36px !important;*/\n/*  top: -16px !important;*/\n/*  outline: none !important;*/\n/*}*/\n\n/*::ng-deep .ng5-slider .ng5-slider-bubble {*/\n/*  bottom: 2px !important;*/\n/*  !* visibility: hidden !important; *!*/\n/*}*/\n\n/*::ng-deep .ng5-slider {*/\n/*  margin: 16px 0 15px !important;*/\n/*}*/\n\n/*::ng-deep .ng5-slider .ng5-slider-pointer:after {*/\n/*  top: 8px !important;*/\n/*  content: \"\" !important;*/\n/*  background: #6e5eff !important;*/\n/*  display: block !important;*/\n/*  content: \" \" !important;*/\n/*  background-size: 28px 28px !important;*/\n/*  height: 20px !important;*/\n/*  width: 20px !important;*/\n/*}*/\n\n/*::ng-deep.ng5-slider .ng5-slider-selection {*/\n/*  z-index: 2;*/\n/*  background: hsl(11deg 100% 62%) !important;*/\n/*  border-radius: 2px;*/\n/*}*/\n\n/*::ng-deep .ng5-slider .ng5-slider-bar-wrapper {*/\n/*  padding-top: 4px !important;*/\n/*  height: 37px !important;*/\n/*}*/\n\n/*::ng-deep .ng5-slider .ng5-slider-bar {*/\n/*  height: 26px !important;*/\n/*}*/\n\n/*::ng-deep .ng5-slider .ng5-slider-pointer:after {*/\n/*  content: \"\";*/\n/*  width: 11px !important;*/\n/*  height: 19px !important;*/\n/*  left: 5px !important;*/\n/*}*/\n\n.slide-view {\n    border: 6px solid #6e5eff;\n    position: absolute;\n    width: 100%;\n    bottom: 30px;\n    z-index: 144;\n}\n\n::ng-deep .marker {\n    display: none !important;\n}\n\n.group-select-btn {\n    width: 100%;\n    background: white;\n    border-bottom: 1px solid #cac9c9;\n    border-left: 0;\n    border-right: 0;\n    border-top: 0;\n    border-radius: 0;\n    outline: none !important;\n    color: black;\n    position: relative;\n}\n\n.dropdown-menu ul {\n    list-style: none;\n    padding-left: 0px;\n}\n\n.dropdown-menu ul li {\n    border-bottom: 1px solid #80808094;\n    padding-left: 11px;\n    margin-top: 7px;\n    color: #605f5f;\n    font-size: 12px;\n}\n\n.dropdown-menu .form-control {\n    margin-top: 11px;\n    border-radius: 0;\n    padding: 5px;\n    outline: none;\n}\n\n.dropdown-menu {\n    min-width: 22.4rem;\n    top: -277px;\n}\n\n/* WC 08282022\n.dropdown-item {\n  padding: 0 !important;\n}\n*/\n\n.grpText {\n    font-size: 16px !important;\n    font-weight: 600;\n}\n\n.check-input {\n    float: right;\n    margin-right: 10px;\n}\n\n/* Checkbox code */\n\n.round {\n    position: relative;\n}\n\n.round label {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 50%;\n    cursor: pointer;\n    height: 18px;\n    width: 18px;\n    left: 0;\n    position: absolute;\n    top: -3px;\n}\n\n.round label:after {\n    border-top: none;\n    border-right: none;\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    left: 7px;\n    opacity: 0;\n    position: absolute;\n    top: 8px;\n}\n\n.round input[type=\"checkbox\"] {\n    visibility: hidden;\n}\n\n.dropdown-menus {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 10rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #212529;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n}\n\n.round input[type=\"checkbox\"]:checked+label {\n    background-color: #6e5eff;\n    border-color: red;\n    border: 3px solid #6e5eff;\n    height: 18px;\n    width: 18px;\n}\n\n.round input[type=\"checkbox\"]:checked+label:after {\n    opacity: 1;\n    border-radius: 50%;\n    height: 18px;\n    width: 18px;\n}\n\n#dropdownMenu2 {\n    text-align: left;\n}\n\n.second-ul {\n    height: 100px;\n    overflow: scroll;\n}\n\n.first-ul {\n    height: 100px;\n    overflow: scroll;\n}\n\n.dropdown-menu [type=\"checkbox\"] {\n    width: 35px;\n    height: 15px;\n}\n\n.addChoiceDropDown .dropdown-menu{\n    min-width: 8.2rem;\n    padding: 0 !important;\n}\n.addChoiceDropDown .dropdown-menu .dropdown-item{\n    font-size: 14px;\n}\n\n.addChoiceDropDown .dropdown-item:focus,\n.addChoiceDropDown .dropdown-item:hover {\n    background-color: rgb(241 234 254) !important;\n    color: #6c2fbb !important;\n}\n.addChoiceDropDown .dropdown-item.active, \n.addChoiceDropDown .dropdown-item:active {\n    background-color: inherit;\n    color: inherit;\n}\n\n.privacy-text {\n    position: absolute;\n    left: 0;\n    top: 0px;\n}\n\n.searchIcon {\n    color: #808080eb;\n}\n\n.searchbox {\n    display: flex;\n    align-items: center;\n    border: 1px solid #80808047;\n    margin: 4px;\n    border-radius: 3px;\n}\n\n.follow-search {\n    margin: 3px;\n    width: 97%;\n    font-size: 14px;\n    border-radius: 3px;\n    border: none;\n}\n\n.btn {\n    outline: none;\n    box-shadow: none;\n}\n\n.example-full-width {\n    width: 100%;\n}\n\n.grabbable {\n    cursor: move;\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab;\n}\n\n.grabbable:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n}\n\n.btn-link {\n    font-size: 14px;\n}\n\n\n.add-pathways-container {\n    height: 82%;\n    width: 460px;\n    position: fixed;\n    z-index: 99;\n    top: 70px;\n    right: 5px;\n}\n\n.add-pathways-container .path-img {\n    border-radius: 13px;\n    max-height: 250px;\n    width: 100%;\n}\n\n.civ-remove {\n    background: #d3d3d3;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 5px 10px;\n    border: none;\n    border-radius: 0 6px 0 6px;\n}\n\n.civ-paths-btn {\n    display: inline-flex;\n    align-items: center;\n    background: rgba(100, 56, 180, 0.05);\n    border: 1px solid #6438B4;\n    border-radius: 50px;\n    font-weight: 500;\n    font-size: 14px;\n    color: #6438B4;\n    padding: 0 16px;\n    margin: 5px;\n    min-height: 50px;\n    position: relative;\n}\n\n.civ-paths-btn i {\n    display: none;\n    cursor: pointer;\n    margin-right: -5px;\n    margin-left: 5px;\n}\n\n.civ-paths-btn:hover i {\n    display: inline-block;\n}\n\n.civ-message-body {\n    display: flex;\n}\n\n.civ-message-body.from {\n    justify-content: flex-start;\n}\n\n.civ-message-body.to {\n    justify-content: flex-end;\n}\n\n.civ-message {\n    display: inline-block;\n    border-radius: 1.5rem;\n    margin-bottom: 15px;\n    padding: 8px 20px;\n    position: relative;\n    /*font-size: 20px;*/\n}\n\n.civ-message-body.to .civ-message {\n    background-color: #9b4dca;\n    color: #fff;\n    margin-left: 100px;\n    width: 200px;\n}\n\n.civ-message .type-image {\n    width: 100px;\n}\n\n.civ-message-body.from .civ-message {\n    background-color: #E5E4E9;\n    color: #363636;\n    margin-right: 100px;\n}\n\n.civ-message-body.to+.civ-message-body.to,\n.civ-message-body.from+.civ-message-body.from {\n    margin-top: -10px;\n}\n\n.civ-message-suggestion {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n}\n\n.civ-message-suggestion .list-group {}\n\n.civ-message-suggestion .list-group-item {\n    padding: 0.5rem;\n}\n\n.civ-message-suggestion .choice {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n}\n\n\n.civr-tab {\n    width: 100%;\n\n}\n\n.civr-tab .nav-tabs {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    border: none;\n}\n\n.civr-tab .nav-tabs .nav-link {\n    border: none;\n    background: transparent;\n    list-style: none;\n    font-weight: 500;\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0px 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.civr-tab .nav-tabs .nav-link svg {\n    fill: #878395;\n}\n\n.civr-tab .nav-tabs .nav-link.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.civr-tab .nav-tabs .nav-link.active svg {\n    fill: rgba(108, 47, 187, 1);\n}\n\n\n.civr-tab .pro-img {\n    width: 50px;\n    height: 50px;\n    border-radius: 10px;\n}\n\n.civr-tab .profile-image {\n    width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n    border-radius: 10px;\n}\n\n.civr-tab .civr-username {\n    margin: 10px;\n}\n\n.civr-tab .civr-checkbox {\n    display: flex !important;\n    align-items: center;\n    line-height: 0px;\n}\n\n.popup-objective {\n    z-index: 1;\n    position: absolute;\n    background: white;\n    padding: 0 7px;\n    border-radius: 6px;\n    width: fit-content;\n    top: 52px;\n    right: 0;\n    width: 200px;\n    height: 210px;\n    overflow: auto;\n}\n\n.objective-img {\n    height: 48px;\n    display: flex;\n    align-items: center;\n    width: fit-content;\n}\n\n.popup-objective ul {\n    text-align: start;\n    padding-left: 25px;\n}\n\n.popup-objective li {\n    margin-top: 10px;\n}\n\n.example-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.example-list li {\n    display: table-cell;\n    padding: 4px;\n}\n\n.example-container {\n    display: flex;\n    flex-wrap: wrap;\n    min-width: 600px;\n    max-width: 900px;\n}\n\n.example-box {\n    width: 200px;\n    height: 200px;\n    border: solid 1px #ccc;\n    font-size: 30pt;\n    font-weight: bold;\n    color: rgba(0, 0, 0, 0.87);\n    cursor: move;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    background: #fff;\n    border-radius: 4px;\n    position: relative;\n    z-index: 1;\n    transition: box-shadow 200ms cubic-bezier(0, 0, 0.2, 1);\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.example-box:active {\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n        0 8px 10px 1px rgba(0, 0, 0, 0.14),\n        0 3px 14px 2px rgba(0, 0, 0, 0.12);\n    opacity: .6;\n}\n\n.cdk-drop-list {\n    display: flex;\n    padding-right: 10px;\n    padding-bottom: 10px;\n}\n\n.cdk-drag-preview {\n    box-sizing: border-box;\n    border-radius: 4px;\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n        0 8px 10px 1px rgba(0, 0, 0, 0.14),\n        0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-placeholder {\n    opacity: .3;\n}\n\n.cdk-drag-animating {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\nbutton {\n    margin-right: 4px;\n}\n\n.w-qus {\n    width: 3.2rem;\n    height: 3.2rem;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n.userPromptSection{\n    padding-right: 25px;\n    padding-left: 5px;\n}\n\n.userPromptSection input{\n    border-bottom: 1px solid #cccccc !important;\n}\n.contibutorsTabs p{\n    margin: 0;\n    font-size: 17px;\n    cursor: pointer\n}\n.activeTab{\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n::ng-deep .cdk-overlay-container:has(.recordSection) .create-video-modal {\n    visibility: hidden;\n}\n@media (max-width: 1034px) {\n    .tree-Modal .tree-card-content .check-line input {\n        width: 20vw;\n    }\n}\n@media (max-width: 565px) {\n    .tree-Modal .tree-card-content .userPromptSection >div:first-child {\n       flex-direction: column;\n       gap: 0 !important;\n       margin-bottom: 10px;\n       margin-top: 5px;\n       font-size: 15px;\n    }\n    .tree-Modal .tree-card-content .userPromptSection >div:last-child i {\n       vertical-align: bottom;\n    }\n}\n@media (max-width: 434px) {\n    .tree-Modal .tree-card-content .chexk-box-top label {\n        width: 100%;\n        margin-bottom: 6px !important;\n        font-size: 15px;\n    }\n    .tree-Modal .tree-card-content .mat-card-title-group .mat-card-sm-image {\n        width: 50px;\n        height: 50px;\n    }\n    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleChoice {\n        padding-left: 7px !important;\n    }\n    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleEdit,\n    .tree-Modal .tree-card-content .mat-card-title-group .videoTitleUpload {\n        padding-inline: 0 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
